import { fundingRateIsCurrent, fundingReceiveTargetD6, fundingSettlementValue, } from '../amount/fx.js';
import { addUnits } from '../amount/money.js';
export function withdrawalAmount(input, balanceD6, currency, now, limits, sellQuote = false) {
    const unavailable = {
        amountD6: null,
        maximumUnits: null,
        minimumUnits: null,
        boundary: null,
    };
    if (currency.status !== 'ready' || !currency.fx || !fundingRateIsCurrent(currency.fx, now))
        return unavailable;
    const maximumD6 = limits?.maximumD6 && BigInt(limits.maximumD6) < BigInt(balanceD6)
        ? limits.maximumD6
        : balanceD6;
    const minimumUnits = limits?.minimumD6
        ? fundingSettlementValue(limits.minimumD6, currency.currency, currency.decimals, currency.fx, 'up')
        : null;
    const maximumUnits = fundingSettlementValue(maximumD6, currency.currency, currency.decimals, currency.fx, 'down');
    const convertedD6 = input && BigInt(input) > 0n
        ? fundingReceiveTargetD6(input, currency.currency, currency.decimals, currency.fx)
        : null;
    // MoonPay sell previews round USDC to hundredths. Floor before requesting
    // so quote, review and deposit agree without rounding above the wallet budget.
    const sellStepD6 = 10000n;
    const debitD6 = convertedD6 === null
        ? null
        : sellQuote
            ? (BigInt(convertedD6) / sellStepD6) * sellStepD6
            : BigInt(convertedD6);
    const amountD6 = debitD6 === null || debitD6 === 0n ? null : debitD6.toString();
    const boundary = input && minimumUnits && BigInt(input) > 0n && BigInt(input) < BigInt(minimumUnits)
        ? { kind: 'minimum', amountUnits: minimumUnits }
        : input && BigInt(input) > BigInt(maximumUnits)
            ? { kind: 'maximum', amountUnits: maximumUnits }
            : null;
    return { amountD6, maximumUnits, minimumUnits, boundary };
}
export function withdrawalFeeEstimate(quote, amountD6, input, currency, decimals) {
    if (!quote ||
        !input ||
        quote.amountD6 !== amountD6 ||
        quote.currency !== currency ||
        quote.decimals !== decimals)
        return null;
    return {
        currency,
        decimals,
        principalUnits: quote.payoutUnits,
        feeUnits: quote.feeUnits,
        totalUnits: addUnits([BigInt(quote.payoutUnits), BigInt(quote.feeUnits)], 99999999999999999999n).toString(),
        targetUnits: input,
        receivedLocalUnits: quote.payoutUnits,
        estimatedOutput: true,
    };
}
